import { z } from 'zod';
import { paginationQuerySchema } from '../common/pagination.js';
export const groupStatusSchema = z.enum(['ACTIVE', 'INACTIVE']);
export const createGroupSchema = z.object({
    nameAr: z.string().trim().min(1, 'nameAr is required'),
    nameEn: z.string().trim().min(1, 'nameEn is required'),
    descriptionAr: z.string().trim().max(2000).optional(),
    descriptionEn: z.string().trim().max(2000).optional(),
});
export const updateGroupSchema = z.object({
    nameAr: z.string().trim().min(1).optional(),
    nameEn: z.string().trim().min(1).optional(),
    descriptionAr: z.string().trim().max(2000).optional(),
    descriptionEn: z.string().trim().max(2000).optional(),
});
export const changeGroupStatusSchema = z.object({ status: groupStatusSchema });
export const groupListQuerySchema = paginationQuerySchema.extend({
    status: groupStatusSchema.optional(),
});
export const setGroupServicesSchema = z.object({
    serviceCodes: z.array(z.string().min(1)),
});
//# sourceMappingURL=group.contract.js.map